import React from 'react';
import CustomInput from '../../../../../../components/CustomInput';

export default function SmsTypeSenderInputs({ data, flag, onChange, onChangeDataStore }) {
    return (
        <>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`current_sender_${flag}`}
                    placeholder="Enter sms sender name"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeDataStore(e, flag);
                    }}
                    inputValue={data?.[flag]?.current_sender}
                    labelText="SMS sender name"
                    width="100%"
                />
            </div>
        </>
    );
}
